import { inject, Injectable } from '@angular/core';
import {
  type UpdateLinkedCardsInput,
  type UpdateLinkedCardsMutation,
  type UpdateLinkedCardsMutationVariables,
} from '@reconcept-platform/shared/types';
import { gql } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { getLogRefetchQueries } from '../../utils/log-query-refetch';
import { WorkspaceGraphQLService } from '../../workspace-graphql.service';

@Injectable({
  providedIn: 'root',
})
export class LinkedCardsApi {
  private workspaceGraphQLService = inject(WorkspaceGraphQLService);

  updateLinkedCards(updateLinkedCardsInput: UpdateLinkedCardsInput, removedCardIds: string[] = []) {
    const logRefetchQueries = getLogRefetchQueries(updateLinkedCardsInput.cardId);

    return (
      this.workspaceGraphQLService
        .mutateV2<UpdateLinkedCardsMutation, UpdateLinkedCardsMutationVariables>({
          mutation: gql`
            mutation UpdateLinkedCards($input: UpdateLinkedCardsInput!) {
              updateLinkedCards(input: $input) {
                card {
                  ... on GoalCard {
                    id
                    linkedCards {
                      ... on GoalCard {
                        id
                      }
                      ... on EventCard {
                        id
                      }
                    }
                  }
                  ... on EventCard {
                    id
                    linkedCards {
                      ... on GoalCard {
                        id
                      }
                      ... on EventCard {
                        id
                      }
                    }
                  }
                }
                errors {
                  path
                  message
                }
              }
            }
          `,
          variables: {
            input: updateLinkedCardsInput,
          },
          refetchQueries: logRefetchQueries,
          update: (cache) => {
            [...updateLinkedCardsInput.linkedCardIds, ...removedCardIds].forEach((cardId) => {
              // since we do not know what type card is updated, clean up the cache for both.
              cache.evict({
                id: `GoalCard:${cardId}`,
                fieldName: 'linkedCards',
              });
              cache.evict({
                id: `EventCard:${cardId}`,
                fieldName: 'linkedCards',
              });
              cache.gc();
            });
          },
        })
        // @ts-expect-error TS18048 possibly undefined | TS18049 possibly null or undefined
        .pipe(map((result) => result.data.updateLinkedCards.card.linkedCards))
    );
  }
}
